// @flow
import env from '../../../environment';
import {postCreator} from '../../../http';

export const endpoints = Object.freeze({
  MULTICHAT_STREAM_AUTH: `${env.baseApiUrl}/usher/multichat/sse/authenticate`,
  MULTICHAT_STREAM: `${env.baseApiUrl}/mercury/sse/multichat/stream`,
});

export const multichatRealTimeAuthenticationTokenEndpoint = postCreator(
  endpoints.MULTICHAT_STREAM_AUTH
);

export type RealTimeAuthenticationTokenResponse = {
  token: string,
};
